/* eslint-disable quote-props */
// @ts-nocheck
import { node } from "~/util/dom";
import Adv from "./adv";
import Item from "./item";
import Item3 from "./item3";
import ItemCorrection from "./item-correction";
import { addListener, removeListener, removeListeners, makeEvent } from "~/lib/signals";
import { saveHistory } from "~/util/providers/history";
import { store } from "~/state/store";
import { watch, watchUser } from "~/state/util";
import { isFirmFromPoi } from "~/util/review";
import { makeNoSearchResultsReport, makeSearchReport } from "~/report/search";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import Scene from "~/scene";
import Canonical from "~/canonical";
import { IPoi } from "~/interfaces";
import { setCoordinates } from "~/state/map/state";

const advTitle = node("p", { className: "adv-title" }, _("search.adv"));
const advList = node("ul", { id: "cnt-100040" });

export let advUser = null;

export function fit(searchMeta) {
	if (searchMeta.queryLoc && !searchMeta.queryLoc.noZoom) {
		const bbox = searchMeta.queryLoc.bbox;
		const mark = searchMeta.queryLoc.mark;

		if (bbox) {
			const cz = Scene.computeCenterZoom([
				Scene.coordsFromWGS84(bbox.leftLon, bbox.leftLat),
				Scene.coordsFromWGS84(bbox.rightLon, bbox.rightLat),
			], false, parseInt(Mapy.CUS.search?.searchLocationBBoxTolerance) || 0);

			if (Scene.isM3dActive()) {
				Scene.providers.m3d.setPosition({ x: cz[0].x, y: cz[0].y, mercZ: cz[1]+1, yaw: 0, pitch: -45 });
			} else {
				const [longitude, latitude] = cz[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: cz[1],
					animate: true,
				}));
			}

			Mapy.getComponent("history").save();
		} else if (mark) {
			const locCenter = Scene.coordsFromWGS84(searchMeta.queryLoc.mark.lon, searchMeta.queryLoc.mark.lat);
			const zoom = Mapy.Util.computeZoom(searchMeta.queryLoc);

			if (Scene.isM3dActive()) {
				Scene.providers.m3d.setPosition({ x: locCenter.x, y: locCenter.y, mercZ: zoom+1, yaw: 0, pitch: -45 });
			} else {
				const [longitude, latitude] = locCenter.toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom,
					animate: true,
				}));
			}

			Mapy.getComponent("history").save();
		}
	}

	return Promise.resolve();
}

function processAdv(advertismentData) {
	const items = [];

	if (advertismentData.data) {
		try {
			const data = JSON.parse(advertismentData.data.trim());
			const ads = data.ads || [];

			ads.forEach(advertisment => {
				if (advertisment.adType === "DRTG" || advertisment.adType === "COMBINED") { // jine zatim zobrazovat nechceme #M-8608
					let item = {};

					if (advertisment.adType === "DRTG") {
						item = {
							orig: advertisment,
							title: advertisment.title,
							secondRow: advertisment.shopName || advertisment.manufacturer,
							thirdRow: advertisment.price,
							img: advertisment.imageUrl,
							href: advertisment.clickUrl,
						};
					} else if (advertisment.adType === "COMBINED") {
						item = {
							orig: advertisment,
							title: advertisment.longHeadline,
							secondRow: advertisment.companyName,
							thirdRow: "",
							img: advertisment.adSquareImageUrl,
							href: advertisment.clickUrl,
						};
					}

					if (advertisment.adTracking) {
						if (advertisment.adTracking.impress && advertisment.adTracking.impress.length) {
							item.exImpUrl = advertisment.adTracking.impress;
						}
					}

					items.push(item);
				}
			});
		} catch (exc) {
			//
		}
	}

	return {
		items: items,
		hintBack: () => {
			sssp.served(advertismentData.tracking.served);
		},
	};
}

function getAdv() {
	return new Promise((resolve, reject) => {
		if ("sssp" in window && ["cs", "sk"].indexOf(CONFIG.defaultLang) > -1) {
			sssp.getAds({
				zoneId: 100040,
				id: "cnt-100040",
				width: 480,
				height: 300,
				callback: advertisment => {
					resolve(processAdv(advertisment));
				},
			});
		} else {
			reject();
		}
	});
}

export function setAdvUser(data) {
	advUser = data;
}

export async function callAdv(container, owner) {
	advTitle.remove();
	advList.remove();
	advList.innerHTML = "";

	await getAdv().then(advs => {
		if (advs.items.length) {
			advs.items.forEach(advData => {
				const item = new Adv(owner, advData);

				advList.appendChild(item.getContainer());
			}, owner);

			container.appendChild(advTitle);
			container.appendChild(advList);

			Mapy.getComponent("logger").log("notfound-sklik-show");
		}

		// posleme hint zpatky do reklamy
		advs.hintBack();
	}, () => {});
}

/**
 * @class Zobrazovač výsledků hledání
 */
export class Visualizer {
	_items: Array<Item>;

	_search: SMap.Search;

	constructor() {
		this._sc = [];
		this._layer = null; /* vrstva v mape pro znacky, pokud by nejaky item chtel */
		this._search = null;
		this._scrollTimeout = null;
		this._sd = null;
		this._reportCont = null;
		this._storeUnsubscribe = null;

		this._items = []; /* prvky ve sloupci */

		this._dom = {
			container: node("div", { id: "search-results" }),
			itemsContainer: node("ul"),
			prev: node("button", { className: "submit", innerHTML: _("search.visualizer.previous") }),
			next: node("button", { className: "submit", innerHTML: _("search.visualizer.next") }),
			repeatSearch: node("p", { className: "show-repeat" }),
			ldJSON: node("script", { type: "application/ld+json" }),
		};

		this._dom.container.appendChild(this._dom.itemsContainer);

		this._sc.push(addListener(this, "item-search-click", "_itemClick"));
		this._sc.push(addListener(this, "detail-activated", "_detailActivated"));
		this._sc.push(addListener(this, "detail-deactivated", "_detailDeactivated"));
		this._dom.prev.addEventListener("click", this, false);
		this._dom.next.addEventListener("click", this, false);
		this._dom.repeatSearch.addEventListener("click", this, false);
		Mapy.getComponent("layout").getScrollNode().addEventListener("scroll", this, false);

		this._buildLayer();
	}

	destroy() {
		this._clear();
		this._dom.prev.removeEventListener("click", this, false);
		this._dom.next.removeEventListener("click", this, false);
		this._dom.repeatSearch.removeEventListener("click", this, false);
		Mapy.getComponent("layout").getScrollNode().removeEventListener("scroll", this, false);
		removeListeners(this._sc);
		this._search = null;
		if (this._scrollTimeout) {
			window.clearTimeout(this._scrollTimeout);
			this._scrollTimeout = null;
		}
		this._dom.container.remove();
		this._dom.ldJSON.remove();
	}

	/**
	 * Nove vysledky hledani
	 * @param {SMap.Search} search
	 * @param {Mapy.Search} state
	 */
	load(search, isMapSearch) {
		this._clear();
		this._search = search;
		this._buildResults(isMapSearch);
	}

	getContainer() {
		return this._dom.container;
	}

	addFilterNode(element) {
		if (this._correctedItem) {
			this._correctedItem.getContainer().after(element);
		} else {
			this._dom.itemsContainer.before(element);
		}
	}

	getLayer() {
		return this._layer;
	}

	showErrorMsg(type, clear) {
		if (clear) {
			this._clear();
		}

		if (type === "repeat") {
			const btn = node("button", { innerHTML: _("error.tryAgain") });

			this._dom.repeatSearch.innerHTML = _("error.info", btn.outerHTML);
			this._dom.container.append(this._dom.repeatSearch);
		} else if (type === "offFilters") {
			const text = Mapy.Util.node("p", { className: "show-off-filters" });

			text.innerHTML = _("search.visualizer.offFilters");

			const span = text.querySelector("span");

			if (span) {
				span.addEventListener("click", () => {
					const searchComp = Mapy.getComponent("search");
					const state = searchComp.getState();

					searchComp.clearFilters();
					searchComp.mapSearch = true;
					searchComp.search({
						query: searchComp.getQuery(),
						listCategory: state.cat,
						searchOrigin: "filter_results",
					});
					Mapy.getComponent("history").save();
				}, false);
			}

			this._dom.container.append(text);
		} else if (type === "mapPan") {
			const text = Mapy.Util.node("p", { className: "error-mappan" });

			text.innerHTML = _("search.visualizer.mapPan");
			this._dom.container.append(text);
		}
	}

	hoverItem(data) {
		for (let index = 0; index < this._items.length; index++) {
			const item = this._items[index];
			const itemData = item.getData();

			if (itemData.source === data.source && itemData.id === data.id) {
				item.setState(data.state === "enter");
			}
		}
	}

	_detailActivated() {
		this._dom.ldJSON.remove();
	}

	_detailDeactivated() {
		if (Mapy.getComponent("search").isActive() && this._search?.getResults().length) {
			document.head.appendChild(this._dom.ldJSON);
		}
	}

	_clear() {
		//this._layer.removeAll("search");
		for (let index = 0; index < this._items.length; index++) {
			this._items[index].destroy();
		}

		this._items = [];

		if (this._correctedItem) {
			this._correctedItem.destroy();
			this._correctedItem = null;
		}

		if (this._reportCont) {
			this._reportCont.remove();
			this._reportCont = null;
		}

		this._storeUnsubscribe && this._storeUnsubscribe();
		this._storeUnsubscribe = null;

		setAdvUser(null);

		Mapy.Util.clear(this._dom.container);
		Mapy.Util.clear(this._dom.itemsContainer);

		this._dom.container.appendChild(this._dom.itemsContainer);
	}

	_itemClick(event) {
		const index = this._items.indexOf(event.target);
		const data = this._items[index].getData();
		const searchMarkers = Mapy.getComponent("search").getMarkers();
		const corr = Mapy.getComponent("search").correction;
		const fromMarker = searchMarkers ? searchMarkers.getMarker(data.source, data.id).marker : null;
		const logObj = {
			index: index + 1 + (this._search ? this._search.getPage() * this._search.getOptions().pageSize : 0),
			name: data.title.trim(),
		};

		if (corr && corr.correctorId === 4) {
			// eslint-disable-next-line camelcase
			logObj.query_var = data.correctedResult ? corr.correctedQuery : Mapy.getComponent("search").getState().q || "";
		}

		if (data.extend?.poi && data.extend.poi.booking) {
			// eslint-disable-next-line camelcase
			logObj.result_type = "booking";
		}

		// vysledek hledani s matched key value
		if (data.matchedKeyVal) {
			// eslint-disable-next-line camelcase
			logObj.result_type = "search_k";
		}

		const filters = Mapy.getComponent("search").getFilters();

		if (Object.keys(filters).length) {
			// eslint-disable-next-line camelcase
			logObj.filter_id = "";
			// eslint-disable-next-line camelcase
			logObj.filter_type = "";

			for (const filter in filters) {
				if (filter in filters) {
					// eslint-disable-next-line camelcase
					logObj.filter_id += (logObj.filter_id === "" ? "" : ",") + filters[filter].id;
					// eslint-disable-next-line camelcase
					logObj.filter_type += (logObj.filter_type === "" ? "" : ",") + filters[filter].type;
				}
			}
		}

		// analytika - nove logovani sjednocene s appkou
		Mapy.Util.analyticsSearchSelection(logObj, data, data);

		// nova analytika pro best review
		if (data.review?.best_review) {
			Mapy.getComponent("logger").log("searchresult_with_review", {
				index: logObj.index,
				typeid: data.typeId,
				id: data.id,
				source: data.source,
				query: Mapy.getComponent("search").getQuery(),
			});
		}

		const historyData = {
			title: data.title,
			source: "web",
			type: data.source === "coor" ? "query" : "poi",
		};

		if (data.source !== "coor") {
			historyData.data = {
				entitySource: data.source,
				entityId: data.id,
				lon: data.mark.lon,
				lat: data.mark.lat,
			};
		}

		const state = store.getState();
		const { user } = state.user;
		const { longitude, latitude, zoom } = state.map;

		saveHistory(user, historyData).then(() => {}, () => {});

		// pokud otevira do noveho okna, tak my po odeslani analytiky a ulozeni do historie koncime akce
		if (Mapy.Util.linkToNewWindow(event.data.event) || event.data.event.type === "auxclick" || event.data.event.type === "mousedown") {
			return;
		}

		const searchComp = Mapy.getComponent("search");

		searchComp.disablePanelLoad = true;
		searchComp.detailOpening = true;
		searchComp.rememberCenterZoom({
			center: Scene.coordsFromWGS84(longitude, latitude),
			zoom,
		});
		searchComp.timeoutFocus(2000);
		const formWidth = searchComp.getFormWidth();

		if (data.resultType && ["entity", "point"].indexOf(data.resultType) > -1 && data.mmsource === "dim") {
			Mapy.getComponent("dimcurator").setState({
				dim: data.mmid,
				search: {
					query: searchComp.getQuery(),
					hasResults: searchComp.hasResults(),
				},
			}).loadData().finally(() => {
				Mapy.getComponent("history").save();
				Mapy.getComponent("search").detailOpening = false;
			});
		} else {
			Mapy.getComponent("detail").setState({
				source: data.source,
				id: data.id,
				show: true,
				fromMarker: fromMarker,
				search: {
					query: Mapy.getComponent("search").getQuery(),
					hasResults: true,
					width: formWidth,
				},
			}).then(() => {
				Mapy.getComponent("history").save();
				Mapy.getComponent("search").detailOpening = false;

				if (Mapy.Util.isSmallResolution()) {
					Mapy.getComponent("layout").checkBottomPanel();
				}
			}, () => {});
		}


		if (isFirmFromPoi(data)) { // pokud se jedna o firemni poi, nastavime posluchac, aby se poslala analytika
			this._sd = addListener(this, "detail-activated", "_detailLoaded");
		}

		/* nevolame save historie, neb se ulozi pri zmene mapy */
	}

	_detailLoaded() {
		if (this._sd) {
			removeListener(this._sd);
			this._sd = null;
		}
	}

	showNoResultsError() {
		this._clear();
		this._noResultsError();
	}

	_noResultsError() {
		const wtUser = watch(store.getState, "user", watchUser);

		this._storeUnsubscribe = store.subscribe(wtUser((newData, oldData) => {
			if (Mapy.getComponent("search").isActive() && (newData.user.userPublicId !== oldData.user.userPublicId || newData.user.state !== oldData.user.state)) {
				// musime znova zavolat o reklamu, pac muze byt placeny bez reklam
				setAdvUser({
					userPublicId: newData.user.userPublicId,
					state: newData.user.state,
				});

				callAdv(this._dom.container, this);
			}
		}));

		const { user } = store.getState().user;

		setAdvUser({
			userPublicId: user.userPublicId,
			state: user.state,
		});

		callAdv(this._dom.container, this);

		this._reportCont = makeNoSearchResultsReport();
		this._dom.container.append(this._reportCont);

		if (!document.head.querySelector("meta[name=robots]") && Mapy.getComponent("search") === Mapy.active[0]) {
			const metaRobots = document.createElement("meta");

			metaRobots.setAttribute("name", "robots");
			metaRobots.setAttribute("content", "noindex, nofollow");
			document.head.appendChild(metaRobots);
			Canonical.remove();
		}
	}

	_buildResults(isMapSearch) {
		const pois = this._search.getResults();
		const resultsLength = this._search.getAllResults().length;
		const action = this._search.getAction();
		const filters = this._search.getFilters();
		let notReadyPoi = 0;
		const correction = Mapy.getComponent("search").correction;

		if (correction.quote?.length) {
			this._correctedItem = new ItemCorrection(this, correction);
			this._dom.itemsContainer.before(this._correctedItem.getContainer());
		}

		const from = Mapy.Search.PAGE * this._search.getPage();
		const frag = document.createDocumentFragment();
		let hasPaidResult = false;
		const itemListElement = [];

		/* vyrobit itemy */
		for (let index = 0; index < pois.length; index++) {
			const poi = pois[index] as IPoi;

			if (!poi.ready) {
				notReadyPoi++;
				continue;
			}

			const bestReview = this._search.getBestReview(poi);
			const item = Mapy.CUS.userweb?.searchSponsored ? new Item3(this, poi, from + index, correction, bestReview) : new Item(this, poi, from + index, correction, bestReview);

			this._items.push(item);
			frag.appendChild(item.getContainer());

			if (poi.stats?.isPaid) {
				hasPaidResult = true;
			}

			itemListElement.push({
				"@type": "ListItem",
				position: itemListElement.length + 1,
				item: {
					"@type": "LocalBusiness",
					name: poi.multiTitle?.length ? poi.multiTitle[0] : poi.title,
					geo: {
						"@type": "Geocoordinates",
						latitude: poi.mark.lat,
						longitude: poi.mark.lon,
					},
					...poi.extend?.address
						? {
							address: {
								"@type": "PostalAddress",
								...poi.extend.address.country_iso_alpha
									? { addressCountry: poi.extend.address.country_iso_alpha }
									: poi.extend.address.country_iso === "203"
										? { addressCountry: "CZ" }
										: {},
								...poi.extend.address.city ? { addressLocality: poi.extend.address.city } : {},
								...poi.extend.address.regions?.length ? { addressRegion: poi.extend.address.regions[0] } : {}, //"{{first-level-region >> kraje}}", // Pokud umíme propsat kraj, jestli ne tak nedávat
								...poi.extend.address.zip ? { postalCode: poi.extend.address.zip } : {},
								...Object.keys(poi.titleVars || {}).length && poi.titleVars.locationMain2.length ? { streetAddress: poi.titleVars.locationMain2[0] } : {},
							},
						}
						: {},
					// eslint-disable-next-line dot-notation
					...Object.keys(poi.media?.urls || {}).length && (poi.media.urls["1x1"] || poi.media.urls["16x9"])
						? {
							image: [
								// eslint-disable-next-line dot-notation
								...poi.media.urls["1x1"] ? [Mapy.CDN.setSize(poi.media.urls["1x1"], Mapy.CDN.SIZE_600_600)] : [],
								// eslint-disable-next-line dot-notation
								...poi.media.urls["16x9"] ? [Mapy.CDN.setSize(poi.media.urls["16x9"], Mapy.CDN.SIZE_400_225)] : [],
							],
						}
						: {},
					...poi.review && poi.review.use_rating && poi.review.review_rating_stars && poi.review.total
						? {
							aggregateRating: {
								"@type": "AggregateRating",
								"ratingValue": parseFloat(poi.review.review_rating_stars.toFixed(1)),
								"reviewCount": parseFloat(poi.review.total.toFixed(1)),
							},
						}
						: {},
					url: `https://${CONFIG.BASE_URL}/?source=${poi.source}&id=${poi.id}`,
				},
			});
		}

		if (resultsLength) {
			const json = {
				"@context": "https://schema.org",
				"@type": "ItemList",
				"itemListElement": itemListElement,
			};

			this._dom.ldJSON.textContent = JSON.stringify(json);
			document.head.appendChild(this._dom.ldJSON);
		}

		this._dom.itemsContainer.appendChild(frag);

		/* strankovadlo */
		if (notReadyPoi < pois.length && (resultsLength-notReadyPoi) > Mapy.Search.PAGE) {
			this._buildPager();
		}

		hasPaidResult && this._dom.container.append(node("p", { className: "search-results-pay-info", textContent: _("detail.content.review2.seznamSearchNotice") }));

		// text pro zobrazeni hlaseni chyb na konci vysledku (nebo pokud je vysledek hledani prazdny)
		if (!pois.length && !action) {
			this._noResultsError();
		} else {
			this._reportCont = makeSearchReport();
			this._dom.container.append(this._reportCont);
			Canonical.remove();
			Canonical.setByPage();
		}

		if ((notReadyPoi === pois.length && this._search.descriptionStatus.toString().charAt(0) === "2") || (pois.length && this._search.descriptionStatus.toString().charAt(0) !== "2")) {
			this.showErrorMsg("repeat");
		} else if (!action || action?.type === "detail" || isMapSearch) {
			const errorMsg = filters?.length && this._items.length === 0 ? "offFilters" : isMapSearch && this._items.length === 0 ? "mapPan" : "";

			errorMsg && this.showErrorMsg(errorMsg);
		}

		// odskrolovani nahorú
		Mapy.getComponent("layout").getScrollNode().scrollTop = 0;

		this._scrollTimeout = window.setTimeout(() => {
			this._countViewItems();
		}, 300);
	}

	_buildLayer() {
		this._layer = Mapy.getComponent("masakovac");
	}

	handleEvent(event) {
		switch (event.currentTarget) {
			case this._dom.next:
				Mapy.getComponent("search").noResultAction = true;
				this._search.setPage(this._search.getPage()+1);
				makeEvent("search-paging", this, { direction: 1 });
				Mapy.getComponent("history").save();
				break;
			case this._dom.prev:
				Mapy.getComponent("search").noResultAction = true;
				this._search.setPage(this._search.getPage()-1);
				makeEvent("search-paging", this, { direction: -1 });
				Mapy.getComponent("history").save();
				break;
			case this._dom.repeatSearch:
				if (event.target.tagName.toLowerCase() === "button") {
					Mapy.getComponent("search").search({
						query: Mapy.getComponent("search").getQuery(),
						searchOrigin: "search_repeat",
					});
				}
				break;
			case Mapy.getComponent("layout").getScrollNode():
				if (this._scrollTimeout) {
					window.clearTimeout(this._scrollTimeout);
					this._scrollTimeout = null;
				}
				this._scrollTimeout = window.setTimeout(() => {
					this._countViewItems();
				}, 300);
				break;
			default:
				break;
		}
	}

	_buildPager() {
		const count = this._search.getAllResults().length;

		if (count <= Mapy.Search.PAGE) {
			return;
		}

		const page = this._search.getPage() + 1;
		const pages = Math.ceil(count / Mapy.Search.PAGE);

		if (page > 1) {
			this._dom.container.appendChild(this._dom.prev);
		}

		if (page < pages) {
			this._dom.container.appendChild(this._dom.next);
		}
	}

	_countViewItems() {
		const layout = Mapy.getComponent("layout");
		const scrollHeight = layout.getScrollNode().offsetHeight;
		const scrollTop = layout.getScrollNode().scrollTop;
		const viewConst = 1/2; // musi byt videt alespon pulka itemu, aby byl oznacen ze je v pruhledu
		let anyInView = false;

		for (let index = 0; index < this._items.length; index++) {
			const item = this._items[index];

			if (item.isReported()) {
				continue;
			}

			const con = item.getContainer();
			const actualPosition = con.offsetTop - scrollTop;

			if (scrollHeight > (actualPosition + con.offsetHeight) * viewConst && (actualPosition + con.offsetHeight) * viewConst > 0) {
				anyInView = true;
				item.sendReport(index + 1);
			} else if (anyInView) {
				break;
			}
		}
	}
}
